export const REMOVE_ITERATE_BY = 'REPORTING_REMOVE_ITERATE_BY ';

export const removeIterateBy = iterateByValues => ({
  type: REMOVE_ITERATE_BY,
  iterateByValues,
});
